import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Lic. Carolina M.',
  location: 'Buenos Aires',
  text: 'Antes perdía dos horas armando cada plan desde cero. Con los guiones de consulta y el checklist de primera visita ahora resuelvo un plan completo en veinte minutos, y pude duplicar la cantidad de pacientes que atiendo por semana.'
}, {
  name: 'Lic. Valentina R.',
  location: 'CABA',
  text: 'Mis pacientes abandonaban a las tres semanas porque no tenía un seguimiento estructurado. Empecé a usar las planillas de evolución y los materiales de adherencia, y hoy ocho de cada diez completan el tratamiento sin frenar.'
}, {
  name: 'Lic. Agustina P.',
  location: 'Córdoba',
  text: 'Cobraba muy poco y no sabía cómo justificar un aumento. Apoyada en las plantillas de informes y el guion de cierre profesionalicé toda mi propuesta y subí los honorarios un 40% sin perder pacientes.'
}, {
  name: 'Lic. Florencia D.',
  location: 'La Plata',
  text: 'Sentía inseguridad cada vez que llegaba un paciente con patología. Con el material clínico y el checklist de evaluación armé mis propios protocolos, y ahora manejo casos de diabetes, hipertensión y sobrepeso con total claridad.'
}];
export function Testimonials() {
  return <div className="py-6 px-4 max-w-5xl mx-auto" data-id="element-215">
      <p className="text-center text-sm font-bold text-mint/80 uppercase tracking-widest mb-4" data-id="element-216">
        Resultados reales de colegas
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-217">
        {testimonials.map((t, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: idx * 0.08
      }} className="bg-surface border border-mint/15 rounded-xl p-5 shadow-lg shadow-black/40 flex flex-col" data-id="element-218">
            <div className="flex items-center gap-0.5 mb-3" data-id="element-219">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={12} className="text-accent fill-accent" data-id="element-220" />)}
            </div>

            <p className="text-dark/80 text-sm leading-relaxed mb-4 italic flex-1" data-id="element-221">
              "{t.text}"
            </p>

            <div className="flex items-center gap-2 pt-4 border-t border-mint/10" data-id="element-222">
              <div className="w-8 h-8 rounded-full bg-mint/20 flex items-center justify-center text-mint text-xs font-bold" data-id="element-223">
                {t.name.split(' ')[1]?.[0] || t.name[0]}
              </div>
              <div data-id="element-224">
                <p className="text-dark/90 text-xs font-bold leading-tight" data-id="element-225">
                  {t.name}
                </p>
                <p className="text-dark/50 text-[10px]" data-id="element-226">{t.location}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </div>;
}